import { CameraTargetProps } from '@fabric-web/3d-viewer';

export const buildViewerPayload = (
  isAtViewerPage: boolean,
  cameraTarget: CameraTargetProps | undefined,
  hasSingleAssembly: boolean = false,
  poiId?: string | null,
  sphericalName?: string
) => {
  if (!hasSingleAssembly || !isAtViewerPage || !cameraTarget) return {};

  const [lx, ly, lz] = cameraTarget.lookAt;
  const [px, py, pz] = cameraTarget.position ?? [0, 0, 0];

  return {
    includeBoundingBox: true,
    poiId: poiId ?? '',
    position: { x: px, y: py, z: pz },
    lookAt: { x: lx, y: ly, z: lz },
    fov: cameraTarget.fov ?? 0,
    ...(sphericalName && { selectedSpherical: sphericalName }),
  };
};
